/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import PropTypes from "prop-types";
import React from "react";

export const BtnIconSearch = ({ color = "var(--secundario)", className }) => {
  return (
    <svg
      className={`btn-icon-search ${className}`}
      fill="none"
      height="25"
      viewBox="0 0 25 25"
      width="25"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        className="path"
        d="M21.3993 21.2295L17.0493 16.8795M19.3994 11.2295C19.3994 15.6478 15.8177 19.2295 11.3994 19.2295C6.98114 19.2295 3.39941 15.6478 3.39941 11.2295C3.39941 6.81121 6.98114 3.22949 11.3994 3.22949C15.8177 3.22949 19.3994 6.81121 19.3994 11.2295Z"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
    </svg>
  );
};

BtnIconSearch.propTypes = {
  color: PropTypes.string,
};
